import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { initialState, initialSelectedTour } from './initialState';
import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import {
  addGroup,
  addHotel,
  createMember,
  createEvent,
  deleteBid,
  deleteEvent,
  deleteGroup,
  fetchAddBidNote,
  fetchAddTour,
  fetchBidsets,
  fetchBrands,
  fetchFindHotels,
  fetchImportRouteStatus,
  fetchPlaces,
  fetchProposal,
  fetchSearchHotels,
  fetchSendBid,
  fetchSendToTour,
  fetchRemoveTourManager,
  fetchTour,
  fetchTours,
  fetchTourDownload,
  patchBid,
  patchBidset,
  patchEvent,
  patchGroup,
  patchGroupEvent,
  patchMember,
  patchPreferences,
  patchTour,
  postClearRoute,
  postUpdateBids,
  removeMemberFromGroup,
  setFavoriteHotel,
  updateProposal,
  uploadRoster,
  uploadRoute,
  uploadTourImage,
  fetchTourManagers
} from '../../../core/api';
// ------------------------------------
// Constants
// ------------------------------------

export const BID_DELETE_FAILURE = 'BID_DELETE_FAILURE';
export const BID_DELETE_REQUEST = 'BID_DELETE_REQUEST';
export const BID_DELETE_SUCCESS = 'BID_DELETE_SUCCESS';
export const BID_EDIT_FAILURE = 'BID_EDIT_FAILURE';
export const BID_EDIT_REQUEST = 'BID_EDIT_REQUEST';
export const BID_EDIT_SUCCESS = 'BID_EDIT_SUCCESS';
export const BID_SEND_FAILURE = 'BID_SEND_FAILURE';
export const BID_SEND_REQUEST = 'BID_SEND_REQUEST';
export const BID_SEND_SUCCESS = 'BID_SEND_SUCCESS';
export const BID_FILTER_SET = 'BID_FILTER_SET';
export const BID_UPDATE_SEND_REQUEST = 'BID_UPDATE_SEND_REQUEST';
export const BID_UPDATE_SEND_SUCCESS = 'BID_UPDATE_SEND_SUCCESS';
export const BID_UPDATE_SEND_FAILURE = 'BID_UPDATE_SEND_FAILURE';
export const BIDNOTE_EDIT_FETCH_FAILURE = 'BIDNOTE_EDIT_FETCH_FAILURE';
export const BIDNOTE_EDIT_FETCH_REQUEST = 'BIDNOTE_EDIT_FETCH_REQUEST';
export const BIDNOTE_EDIT_FETCH_SUCCESS = 'BIDNOTE_EDIT_FETCH_SUCCESS';
export const BIDSET_LIST_FETCH_FAILURE = 'BIDSET_LIST_FETCH_FAILURE';
export const BIDSET_LIST_FETCH_REQUEST = 'BIDSET_LIST_FETCH_REQUEST';
export const BIDSET_LIST_FETCH_SUCCESS = 'BIDSET_LIST_FETCH_SUCCESS';
export const BRAND_FETCH_FAILURE = 'BRAND_FETCH_FAILURE';
export const BRAND_FETCH_REQUEST = 'BRAND_FETCH_REQUEST';
export const BRAND_FETCH_SUCCESS = 'BRAND_FETCH_SUCCESS';
export const EVENT_ADD_FAILURE = 'EVENT_ADD_FAILURE';
export const EVENT_ADD_REQUEST = 'EVENT_ADD_REQUEST';
export const EVENT_ADD_SUCCESS = 'EVENT_ADD_SUCCESS';
export const EVENT_DELETE_FAILURE = 'EVENT_DELETE_FAILURE';
export const EVENT_DELETE_REQUEST = 'EVENT_DELETE_REQUEST';
export const EVENT_DELETE_SUCCESS = 'EVENT_DELETE_SUCCESS';
export const EVENT_EDIT_FAILURE = 'EVENT_EDIT_FAILURE';
export const EVENT_EDIT_REQUEST = 'EVENT_EDIT_REQUEST';
export const EVENT_EDIT_SUCCESS = 'EVENT_EDIT_SUCCESS';
export const EVENT_SELECT = 'EVENT_SELECT';
export const EVENT_FILTER_SET = 'EVENT_FILTER_SET';
export const GROUP_ADD_REQUEST = 'GROUP_ADD_REQUEST';
export const GROUP_DELETE_FAILURE = 'GROUP_DELETE_FAILURE';
export const GROUP_DELETE_REQUEST = 'GROUP_DELETE_REQUEST';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUP_EDIT_FAILURE = 'GROUP_EDIT_FAILURE';
export const GROUP_EDIT_REQUEST = 'GROUP_EDIT_REQUEST';
export const GROUP_EDIT_SUCCESS = 'GROUP_EDIT_SUCCESS';
export const GROUPEVENT_EDIT_FAILURE = 'GROUPEVENT_EDIT_FAILURE';
export const GROUPEVENT_EDIT_REQUEST = 'GROUPEVENT_EDIT_REQUEST';
export const GROUPEVENT_EDIT_SUCCESS = 'GROUPEVENT_EDIT_SUCCESS';
export const GROUPMEMBER_REMOVE_FAILURE = 'GROUPMEMBER_REMOVE_FAILURE';
export const GROUPMEMBER_REMOVE_REQUEST = 'GROUPMEMBER_REMOVE_REQUEST';
export const GROUPMEMBER_REMOVE_SUCCESS = 'GROUPMEMBER_REMOVE_SUCCESS';
export const HOTEL_FAVORITE_FETCH_FAILURE = 'HOTEL_FAVORITE_FETCH_FAILURE';
export const HOTEL_FAVORITE_FETCH_REQUEST = 'HOTEL_FAVORITE_FETCH_REQUEST';
export const HOTEL_FAVORITE_FETCH_SUCCESS = 'HOTEL_FAVORITE_FETCH_SUCCESS';
export const HOTEL_FIND_FETCH_FAILURE = 'HOTEL_FIND_FETCH_FAILURE';
export const HOTEL_FIND_FETCH_REQUEST = 'HOTEL_FIND_FETCH_REQUEST';
export const HOTEL_FIND_FETCH_SUCCESS = 'HOTEL_FIND_FETCH_SUCCESS';
export const HOTEL_SELECT_FETCH_FAILURE = 'HOTEL_SELECT_FETCH_FAILURE';
export const HOTEL_SELECT_FETCH_REQUEST = 'HOTEL_SELECT_FETCH_REQUEST';
export const HOTEL_SELECT_FETCH_SUCCESS = 'HOTEL_SELECT_FETCH_SUCCESS';
export const IMPORT_ROSTER_FETCH_FAILURE = 'IMPORT_ROSTER_FETCH_FAILURE';
export const IMPORT_ROSTER_FETCH_REQUEST = 'IMPORT_ROSTER_FETCH_REQUEST';
export const IMPORT_ROSTER_FETCH_SUCCESS = 'IMPORT_ROSTER_FETCH_SUCCESS';
export const IMPORT_ROSTER_FETCH_PENDING = 'IMPORT_ROSTER_FETCH_PENDING';
export const IMPORT_ROUTE_FETCH_FAILURE = 'IMPORT_ROUTE_FETCH_FAILURE';
export const IMPORT_ROUTE_FETCH_REQUEST = 'IMPORT_ROUTE_FETCH_REQUEST';
export const IMPORT_ROUTE_FETCH_SUCCESS = 'IMPORT_ROUTE_FETCH_SUCCESS';
export const IMPORT_ROUTE_FETCH_PENDING = 'IMPORT_ROUTE_FETCH_PENDING';
export const CLEAR_ROUTE_FETCH_FAILURE = 'CLEAR_ROUTE_FETCH_FAILURE';
export const CLEAR_ROUTE_FETCH_REQUEST = 'CLEAR_ROUTE_FETCH_REQUEST';
export const CLEAR_ROUTE_FETCH_SUCCESS = 'CLEAR_ROUTE_FETCH_SUCCESS';
export const BID_CLEAR = 'BID_CLEAR';
export const MEMBER_ADD_FAILURE = 'MEMBER_ADD_FAILURE';
export const MEMBER_ADD_REQUEST = 'MEMBER_ADD_REQUEST';
export const MEMBER_ADD_SUCCESS = 'MEMBER_ADD_SUCCESS';
export const MEMBER_EDIT_FAILURE = 'MEMBER_EDIT_FAILURE';
export const MEMBER_EDIT_REQUEST = 'MEMBER_EDIT_REQUEST';
export const MEMBER_EDIT_SUCCESS = 'MEMBER_EDIT_SUCCESS';
export const PLACE_FETCH_FAILURE = 'PLACE_FETCH_FAILURE';
export const PLACE_FETCH_REQUEST = 'PLACE_FETCH_REQUEST';
export const PLACE_FETCH_SUCCESS = 'PLACE_FETCH_SUCCESS';
export const PROPOSAL_FETCH_FAILURE = 'PROPOSAL_FETCH_FAILURE';
export const PROPOSAL_FETCH_REQUEST = 'PROPOSAL_FETCH_REQUEST';
export const PROPOSAL_FETCH_SUCCESS = 'PROPOSAL_FETCH_SUCCESS';
export const PROPOSAL_SEND_FAILURE = 'PROPOSAL_SEND_FAILURE';
export const PROPOSAL_SEND_REQUEST = 'PROPOSAL_SEND_REQUEST';
export const PROPOSAL_SEND_SUCCESS = 'PROPOSAL_SEND_SUCCESS';
export const SEARCH_HOTEL_CLEAR = 'SEARCH_HOTEL_CLEAR';
export const SEARCH_HOTEL_FETCH_FAILURE = 'SEARCH_HOTEL_FETCH_FAILURE';
export const SEARCH_HOTEL_FETCH_REQUEST = 'SEARCH_HOTEL_FETCH_REQUEST';
export const SEARCH_HOTEL_FETCH_SUCCESS = 'SEARCH_HOTEL_FETCH_SUCCESS';
export const SEARCH_PREFS_FETCH_FAILURE = 'SEARCH_PREFS_FETCH_FAILURE';
export const SEARCH_PREFS_FETCH_REQUEST = 'SEARCH_PREFS_FETCH_REQUEST';
export const SEARCH_PREFS_FETCH_SUCCESS = 'SEARCH_PREFS_FETCH_SUCCESS';
export const TOURMGR_REMOVE_FAILURE = 'TOURMGR_REMOVE_FAILURE';
export const TOURMGR_REMOVE_REQUEST = 'TOURMGR_REMOVE_REQUEST';
export const TOURMGR_REMOVE_SUCCESS = 'TOURMGR_REMOVE_SUCCESS';
export const TOURMGR_SEND_HOTELS_FAILURE = 'TOURMGR_SEND_HOTELS_FAILURE';
export const TOURMGR_SEND_HOTELS_REQUEST = 'TOURMGR_SEND_HOTELS_REQUEST';
export const TOURMGR_SEND_HOTELS_SUCCESS = 'TOURMGR_SEND_HOTELS_SUCCESS';
export const TOURMGR_SEND_TOUR_FAILURE = 'TOURMGR_SEND_TOUR_FAILURE';
export const TOURMGR_SEND_TOUR_REQUEST = 'TOURMGR_SEND_TOUR_REQUEST';
export const TOURMGR_SEND_TOUR_SUCCESS = 'TOURMGR_SEND_TOUR_SUCCESS';
export const TOURMGR_SIM_MODE = 'TOURMGR_SIM_MODE';
export const TOUR_ADD_FAILURE = 'TOUR_ADD_FAILURE';
export const TOUR_ADD_REQUEST = 'TOUR_ADD_REQUEST';
export const TOUR_ADD_SUCCESS = 'TOUR_ADD_SUCCESS';
export const TOUR_EDIT_FAILURE = 'TOUR_EDIT_FAILURE';
export const TOUR_EDIT_REQUEST = 'TOUR_EDIT_REQUEST';
export const TOUR_EDIT_SUCCESS = 'TOUR_EDIT_SUCCESS';
export const TOUR_FETCH_FAILURE = 'TOUR_FETCH_FAILURE';
export const TOUR_FETCH_REQUEST = 'TOUR_FETCH_REQUEST';
export const TOUR_FETCH_SUCCESS = 'TOUR_FETCH_SUCCESS';
export const TOUR_FILTER_SET = 'TOUR_FILTER_SET';
export const TOUR_LIST_FETCH_FAILURE = 'TOUR_LIST_FETCH_FAILURE';
export const TOUR_LIST_FETCH_REQUEST = 'TOUR_LIST_FETCH_REQUEST';
export const TOUR_LIST_FETCH_SUCCESS = 'TOUR_LIST_FETCH_SUCCESS';
export const TOUR_SELECT = 'TOUR_SELECT';
export const TOUR_DOWNLOAD_REQUEST = 'TOUR_DOWNLOAD_REQUEST';
export const TOUR_REFRESH_REQUEST = 'TOUR_REFRESH_REQUEST';
export const TOUR_MESSAGE_DISMISS = 'TOUR_MESSAGE_DISMISS';
export const TOUR_MESSAGE_SET = 'TOUR_MESSAGE_SET';
export const TOUR_MANAGER_REQUEST = 'TOUR_MANAGER_REQUEST'
export const TOUR_MANAGER_SUCCESS = 'TOUR_MANAGER_SUCCESS'
// ------------------------------------
// Actions
// ------------------------------------
export function requestingAddBidNote(bid) {
  return {
    type: BIDNOTE_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestAddBidNoteSuccess(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestAddBidNoteFailure(json) {
  return {
    type: BIDNOTE_EDIT_FAILURE,
    payload: json,
  };
}

export function requestingBidEdit(bid) {
  return {
    type: BID_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestBidEditSuccess(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestBidEditFailure(json) {
  return {
    type: BID_EDIT_FAILURE,
    payload: json,
  };
}
export function selectEvent(id) {
  return {
    type: EVENT_SELECT,
    payload: id,
  };
}
export function bidFilterSet(filter) {
  return {
    type: BID_FILTER_SET,
    payload: filter,
  };
}
export function eventFilterSet(filter) {
  return {
    type: EVENT_FILTER_SET,
    payload: filter,
  };
}
export function messageDismiss(payload) {
  return {
    type: TOUR_MESSAGE_DISMISS,
    payload,
  };
}
export function messageSet(payload) {
  return {
    type: TOUR_MESSAGE_SET,
    payload,
  };
}
export function memberEditSuccess(json) {
  return {
    type: MEMBER_EDIT_SUCCESS,
    payload: json,
  };
}
export function memberEditRequest(json) {
  return {
    type: MEMBER_EDIT_REQUEST,
    payload: json,
  };
}
export function memberEditFailure(json) {
  return {
    type: MEMBER_EDIT_FAILURE,
    payload: json,
  };
}
export function memberAddSuccess(json) {
  return {
    type: MEMBER_ADD_SUCCESS,
    payload: json,
  };
}
export function memberAddRequest(json) {
  return {
    type: MEMBER_ADD_REQUEST,
    payload: json,
  };
}
export function memberAddFailure(json) {
  return {
    type: MEMBER_ADD_FAILURE,
    payload: json,
  };
}
export function editEventSuccess(json) {
  return {
    type: EVENT_EDIT_SUCCESS,
    payload: json,
  };
}
export function editEventFailure(json) {
  return {
    type: EVENT_EDIT_FAILURE,
    payload: json,
  };
}
export function editTourSuccess(json) {
  return {
    type: TOUR_EDIT_SUCCESS,
    payload: json,
  };
}
export function editTourFailure(json) {
  return {
    type: TOUR_EDIT_FAILURE,
    payload: json,
  };
}
export function eventAddRequest(json) {
  return {
    type: EVENT_ADD_REQUEST,
    payload: json,
  };
}
export function eventAddSuccess(json) {
  return {
    type: EVENT_ADD_SUCCESS,
    payload: json,
  };
}
export function eventAddFailure(json) {
  return {
    type: EVENT_ADD_FAILURE,
    payload: json,
  };
}
export function eventDeleteRequest(json) {
  return {
    type: EVENT_DELETE_REQUEST,
    payload: json,
  };
}
export function eventDeleteSuccess(json) {
  return {
    type: EVENT_DELETE_SUCCESS,
    payload: json,
  };
}
export function eventDeleteFailure(json) {
  return {
    type: EVENT_DELETE_FAILURE,
    payload: json,
  };
}
export function editGroupEventSuccess(json) {
  return {
    type: GROUPEVENT_EDIT_SUCCESS,
    payload: json,
  };
}
export function editGroupEventFailure(json) {
  return {
    type: GROUPEVENT_EDIT_FAILURE,
    payload: json,
  };
}
export function removeMemberFromGroupRequest() {
  return {
    type: GROUPMEMBER_REMOVE_REQUEST,
    payload: null,
  };
}
export function removeMemberFromGroupSuccess(memberId) {
  return {
    type: GROUPMEMBER_REMOVE_SUCCESS,
    payload: memberId,
  };
}
export function removeMemberFromGroupFailure(detail) {
  return {
    type: GROUPMEMBER_REMOVE_FAILURE,
    payload: detail,
  };
}

export function requestingAddGroup() {
  return {
    type: GROUP_ADD_REQUEST,
    payload: null,
  };
}
export function requestingAddTour() {
  return {
    type: TOUR_ADD_REQUEST,
    payload: null,
  };
}
export function requestingTour(id) {
  return {
    type: TOUR_FETCH_REQUEST,
    payload: id,
  };
}
export function requestingTours() {
  return {
    type: TOUR_LIST_FETCH_REQUEST,
    payload: null,
  };
}

export function requestingTourManagers() {
  return {
    type: TOUR_MANAGER_REQUEST,
    payload: null
  }
}

export function recevieTourManagers(payload) {
  return {
    type: TOUR_MANAGER_SUCCESS,
    payload
  }
}

export function refreshingTour(id) {
  return {
    type: TOUR_REFRESH_REQUEST,
    payload: id,
  };
}
export function requestingHotelFind() {
  return {
    type: HOTEL_FIND_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingHotels(id) {
  return {
    type: SEARCH_HOTEL_FETCH_REQUEST,
    payload: id,
  };
}
export function requestingHotelFavorite() {
  return {
    type: HOTEL_FAVORITE_FETCH_REQUEST,
    payload: null,
  };
}
export function receiveBidsets(json) {
  return {
    type: BIDSET_LIST_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveTour(json) {
  return {
    type: TOUR_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveTours(json) {
  return {
    type: TOUR_LIST_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveFindHotel(json) {
  return {
    type: HOTEL_FIND_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveProposalSend(json) {
  return {
    type: PROPOSAL_SEND_SUCCESS,
    payload: json,
  };
}
export function receiveBidSend(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestingBrands() {
  return {
    type: BRAND_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingPlaces() {
  return {
    type: PLACE_FETCH_REQUEST,
    payload: null,
  };
}
export function importingRoute() {
  return {
    type: IMPORT_ROUTE_FETCH_REQUEST,
    payload: null,
  };
}
export function importRoutePending(payload) {
  return {
    type: IMPORT_ROUTE_FETCH_PENDING,
    payload,
  };
}
export function importRouteFailure(payload) {
  return {
    type: IMPORT_ROUTE_FETCH_FAILURE,
    payload,
  };
}
export function clearRouteRequest() {
  return {
    type: CLEAR_ROUTE_FETCH_REQUEST,
  };
}
export function clearRouteSuccess(payload) {
  return {
    type: CLEAR_ROUTE_FETCH_SUCCESS,
    payload,
  };
}
export function clearRouteFailure(payload) {
  return {
    type: CLEAR_ROUTE_FETCH_FAILURE,
    payload,
  };
}
export function importingRoster() {
  return {
    type: IMPORT_ROSTER_FETCH_REQUEST,
    payload: null,
  };
}
export function importRosterFailure(payload) {
  return {
    type: IMPORT_ROSTER_FETCH_FAILURE,
    payload,
  };
}
export function requestingProposals() {
  return {
    type: PROPOSAL_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingBidsets() {
  return {
    type: BIDSET_LIST_FETCH_REQUEST,
    payload: null,
  };
}
export function addingBidNote() {
  return {
    type: BIDNOTE_EDIT_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingHotelSelect() {
  return {
    type: HOTEL_SELECT_FETCH_REQUEST,
    payload: null,
  };
}
export function receiveBrands(json) {
  return {
    type: BRAND_FETCH_SUCCESS,
    payload: json,
  };
}
export function receivePlaces(json) {
  return {
    type: PLACE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receivePreferences(json) {
  return {
    type: SEARCH_PREFS_FETCH_SUCCESS,
    payload: json,
  };
}

export function receiveHotels(json) {
  return {
    type: SEARCH_HOTEL_FETCH_SUCCESS,
    payload: json,
  };
}
export function clearBids() {
  return {
    type: BID_CLEAR,
    payload: null,
  };
}

export function clearHotels() {
  return {
    type: SEARCH_HOTEL_CLEAR,
    payload: null,
  };
}
export function receiveHotelSelect(json) {
  return {
    type: HOTEL_SELECT_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveHotelFavorite(json) {
  return {
    type: HOTEL_FAVORITE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveGroup(json) {
  return {
    type: GROUP_EDIT_SUCCESS,
    payload: json,
  };
}
export function receiveProposals(json) {
  return {
    type: PROPOSAL_FETCH_SUCCESS,
    payload: json.results,
  };
}
export function receiveRouteImport(json) {
  return {
    type: IMPORT_ROUTE_FETCH_SUCCESS,
    payload: json,
  };
}
export function receiveRosterImport(json) {
  return {
    type: IMPORT_ROSTER_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestingGroupDelete(id) {
  return {
    type: GROUP_DELETE_REQUEST,
    payload: id,
  };
}
export function requestGroupDeleteSuccess(id) {
  return {
    type: GROUP_DELETE_SUCCESS,
    payload: id,
  };
}
export function requestGroupDeleteFailure(id) {
  return {
    type: GROUP_DELETE_FAILURE,
    payload: id,
  };
}
export function requestingBidDelete(id) {
  return {
    type: BID_DELETE_REQUEST,
    payload: id,
  };
}
export function requestBidDeleteSuccess(id) {
  return {
    type: BID_DELETE_SUCCESS,
    payload: id,
  };
}
export function requestBidDeleteFailure(id) {
  return {
    type: BID_DELETE_FAILURE,
    payload: id,
  };
}
export function tourDownloadRequest(id) {
  return {
    type: TOUR_DOWNLOAD_REQUEST,
    payload: id,
  };
}
export function sendBidUpdateRequest() {
  return {
    type: BID_UPDATE_SEND_REQUEST,
  };
}
export function sendBidUpdateSuccess(payload) {
  return {
    type: BID_UPDATE_SEND_SUCCESS,
    payload,
  };
}
export function sendBidUpdateFailure(payload) {
  return {
    type: BID_UPDATE_SEND_FAILURE,
    payload,
  };
}
export function removeTourManagerRequest() {
  return {
    type: TOURMGR_REMOVE_REQUEST,
  };
}
export function removeTourManagerSuccess(payload) {
  return {
    type: TOURMGR_REMOVE_SUCCESS,
    payload,
  };
}
export function removeTourManagerFailure(id) {
  return {
    type: TOURMGR_REMOVE_FAILURE,
    payload: id,
  };
}
export function sendToTourManagerRequest() {
  return {
    type: TOURMGR_SEND_TOUR_REQUEST,
  };
}
export function sendToTourManagerSuccess(payload) {
  return {
    type: TOURMGR_SEND_TOUR_SUCCESS,
    payload,
  };
}
export function sendToTourManagerFailure(id) {
  return {
    type: TOURMGR_SEND_TOUR_FAILURE,
    payload: id,
  };
}
export function activateTourManagerSimMode() {
  return {
    type: TOURMGR_SIM_MODE,
    payload: true, // Default filter options,
  };
}
export function clearTourManagerSimMode() {
  return {
    type: TOURMGR_SIM_MODE,
    payload: false,
  };
}
export function setTourManagerSimMode() {
  return dispatch => {
    const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Collaborator View',
      message: 'View for collaborators.',
      autoDismiss: 0,
      action: {
        label: 'Clear',
        callback: () => dispatch(clearTourManagerSimMode()),
      },
    };
    dispatch(Notifications.success(notificationOpts));
    return dispatch(activateTourManagerSimMode());
  };
}
export function tourFilterSet(filter) {
  return {
    type: TOUR_FILTER_SET,
    payload: filter,
  };
}

export function removeBid(id) {
  return dispatch => {
    dispatch(requestingBidDelete(id));
    return deleteBid(id)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(requestBidDeleteSuccess(id, response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(requestBidDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeBid(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeBid(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidDeleteFailure(id));
      });
  };
}
export function sendBidUpdate(payload) {
  return dispatch => {
    dispatch(sendBidUpdateRequest(payload));
    return postUpdateBids(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(sendBidUpdateSuccess(response));
        // Force reload of bids
        dispatch(clearBids());
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(sendBidUpdateFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(sendBidUpdate(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(sendBidUpdate(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(sendBidUpdateFailure(payload));
      });
  };
}
export function editBid(id, payload) {
  return dispatch => {
    dispatch(requestingBidEdit(payload));
    return patchBid(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(requestBidEditSuccess(response));
        if (['AC', 'PB'].includes(payload.buyer_state)) {
          // Force reload of bids for accept or pre-book
          dispatch(clearBids());
        }
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
              dispatch(requestBidEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidEditFailure(payload));
      });
  };
}
export function addMember(payload) {
  return dispatch => {
    dispatch(memberAddRequest(payload));
    createMember(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {

        if (!response.status) {
          const notificationOpts = {
            title: 'Member Added',
            message: `${response.first_name} ${response.last_name} added to Tour`,
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          dispatch(memberAddSuccess(response));
        }
        else {
          const notificationOpts = {
            title: 'Yikes!',
            message: `Sharing via this option is for clients only! The person you are sharing with already has a login with your company. Please do not use this share function for sharing group with co-workers.`,
            autoDismiss: 15,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(memberAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addMember(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addMember(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(memberAddFailure(payload));
      });
  };
}
export function editMember(id, payload) {
  return dispatch => {
    dispatch(memberEditRequest(payload));
    patchMember(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(memberEditSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(memberEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editMember(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editMember(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(memberEditFailure(payload));
      });
  };
}
export function addEvent(payload) {
  return dispatch => {
    dispatch(eventAddRequest(payload));
    createEvent(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Event Added',
          message: `${payload.name} added to tour.`,
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(eventAddSuccess(response));
        dispatch(refreshTour(response.tour));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(eventAddFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addEvent(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addEvent(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(eventAddFailure(payload));
      });
  };
}
export function editEvent(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(editEventSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(editEventFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editEvent(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editEventFailure(payload));
      });
}
export function removeEvent(id) {
  return dispatch => {
    dispatch(eventDeleteRequest(id));
    return deleteEvent(id)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(eventDeleteSuccess(id, response));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Event Removed',
          message: 'Event removed from Tour. Please verify hotel dates.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(eventDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeEvent(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeEvent(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(eventDeleteFailure(id));
      });
  };
}
export function editGroupEvent(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchGroupEvent(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(editGroupEventSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(editGroupEventFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editGroupEvent(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editGroupEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editGroupEventFailure(payload));
      });
}
export function addTour(payload) {
  return dispatch => {
    dispatch(requestingAddTour());
    return fetchAddTour(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        // Tour added
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Travel Added',
          message: 'Travel plan successfully added.',
          position: 'tr',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(selectTour(response.id));
        dispatch(push(`/tours/${response.id}/overview`));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          return dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}
export function editTour(id, payload) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchTour(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        if (payload.state === 'AC') {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Tour Activated',
            message: 'Sending emails to all members.',
            position: 'tr',
            autoDismiss: 10,
          };
          dispatch(Notifications.success(notificationOpts));
        }
        dispatch(editTourSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(editTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editTour(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editTourFailure(payload));
      });
}
export function editTourImage(id, payload) {
  return dispatch =>
    uploadTourImage(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        if (payload.state === 'AC') {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Tour Activated',
            message: 'Sending emails to all members.',
            position: 'tr',
            autoDismiss: 10,
          };
          dispatch(Notifications.success(notificationOpts));
        }
        dispatch(editTourSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(editTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editTour(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editTourFailure(payload));
      });
}
export function requestToursError(json) {
  return {
    type: TOUR_LIST_FETCH_FAILURE,
    payload: json,
  };
}
export function requestTours() {
  return dispatch => {
    dispatch(requestingTours());
    return fetchTours()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveTours(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}



export function requestTourManagers() {
  return dispatch => {
    dispatch(requestingTourManagers());
    return fetchTourManagers()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(recevieTourManagers(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}


export function addedBidNote(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function addBidNote(id, payload) {
  return dispatch => {
    dispatch(addingBidNote());
    return fetchAddBidNote(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(addedBidNote(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!', error);
        }
      });
  };
}
export function requestTourError(id) {
  return {
    type: TOUR_FETCH_FAILURE,
    payload: id,
  };
}

export function requestTour(id) {
  return dispatch => {
    dispatch(requestingTour(id));
    return fetchTour(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveTour(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${id}/overview`));
            });
          }
          // TODO Handle alll the error cases
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          }
          if (status === 404) {
            console.log('Yikes problem with server. ', status);
          }
          if (status > 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTour(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(requestTourError(id));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Something is wrong. Are you connected to the network?',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestTour(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(requestTourError(id));
        }
        return dispatch(requestTourError(id));
      });
  };
}
export function refreshTour(id) {
  return dispatch => {
    dispatch(refreshingTour(id));
    return fetchTour(id)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveTour(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${id}/overview`));
            });
          }
          // TODO Handle alll the error cases
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          }
          if (status === 404) {
            console.log('Yikes problem with server. ', status);
          }
          if (status > 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTour(id)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Something is wrong. Are you connected to the network?',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestTour(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestTourError(id));
      });
  };
}

export function selectTour(id) {
  return dispatch => {
    if (id !== 'undefined') {
      dispatch(requestTour(id));
    } else {
      dispatch(requestingTours());
    }
    return {
      type: TOUR_SELECT,
      payload: id,
    };
  };
}
function handleImportSuccessResponse(response) {
  return dispatch => {
    const payload = {};
    payload.tour = response.tour;
    const messages = [];
    messages.push({
      key: 'route-import-0',
      msg: `Route imported. ${response.events} events created.`,
    });
    response.warnings.forEach(warn => {
      messages.push({
        key: `route-import-${messages.length}`,
        msg: warn,
        style: 'warning',
      });
    });
    payload.messages = messages;
    return dispatch(receiveRouteImport(payload));
  };
}
export function importRouteStatus(tourId) {
  return dispatch => {
    return fetchImportRouteStatus(tourId)
      .then(checkHttpStatus)
      .then(response => {
        // Handle incomplete response
        const status = response.status;
        if (status === 206) {
          setTimeout(() => {
            dispatch(importRouteStatus(tourId));
          }, 10000);
          return dispatch(importRoutePending());
        }
        // const data = parseJSON(response);
        response.json().then(data => {
          return dispatch(handleImportSuccessResponse(data));
        });
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              return dispatch(
                importRouteFailure({
                  msg: detail.status,
                  key: 'route-import',
                  style: 'danger',
                })
              );
            });
          } else if (status === 504) {
            return dispatch(
              importRouteFailure({
                msg: 'Importing the route took longer than expected. Please reload the page.',
                key: 'route-import',
                style: 'danger',
              })
            );
          } else if (status >= 404) {
            return dispatch(
              importRouteFailure({
                msg: 'Importing the route failed.',
                key: 'route-import',
                style: 'danger',
              })
            );
          }
        }
        // Most likely connection issues
        return dispatch(
          importRouteFailure({
            msg: 'Importing the route failed.',
            key: 'route-import',
            style: 'danger',
          })
        );
      });
  };
}
export function importRoute(tourId, files) {
  return dispatch => {
    dispatch(importingRoute());
    return uploadRoute(tourId, files)
      .then(checkHttpStatus)
      .then(response => {
        // Handle incomplete response
        const status = response.status;
        if (status === 202) {
          dispatch(
            importRoutePending({
              msg: 'Tour is importing. Large tours may take several minutes to process.',
              key: 'route-import',
              style: 'info',
            })
          );
          return dispatch(importRouteStatus(tourId));
        }
        response.json().then(data => {
          return dispatch(handleImportSuccessResponse(data));
        });
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              return dispatch(
                importRouteFailure({
                  msg: detail.status,
                  key: 'route-import',
                  style: 'danger',
                })
              );
            });
          } else if (status === 504) {
            return dispatch(
              importRouteFailure({
                msg: 'Importing the route took longer than expected. Please reload the page.',
                key: 'route-import',
                style: 'danger',
              })
            );
          } else if (status >= 404) {
            return dispatch(
              importRouteFailure({
                msg: 'Importing the route failed.',
                key: 'route-import',
                style: 'danger',
              })
            );
          }
        }
        // Most likely connection issues
        return dispatch(
          importRouteFailure({
            msg: 'Unable to import route.',
            key: 'route-import',
            style: 'danger',
          })
        );
      });
  };
}
export function clearRoute(tourId) {
  return dispatch => {
    dispatch(clearRouteRequest());
    return postClearRoute(tourId, {})
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const payload = {};
        payload.tour = response.tour;
        const messages = [];
        messages.push({
          key: 'route-import-0',
          msg: 'Route cleared. All events removed.',
        });
        response.warnings.forEach(warn => {
          messages.push({
            key: `route-import-${messages.length}`,
            msg: warn,
            style: 'warning',
          });
        });
        payload.messages = messages;
        return dispatch(clearRouteSuccess(payload));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              return dispatch(
                clearRouteFailure({
                  msg: detail.status,
                  key: 'route-import',
                  style: 'danger',
                })
              );
            });
          } else if (status >= 404) {
            return dispatch(
              clearRouteFailure({
                msg: 'Error clearing route.',
                key: 'route-import',
                style: 'danger',
              })
            );
          }
        } else {
          // Most likely connection issues
          return dispatch(
            clearRouteFailure({
              msg: 'Error clearing route.',
              key: 'route-import',
              style: 'danger',
            })
          );
        }
      });
  };
}
export function importRoster(tourId, files) {
  return dispatch => {
    dispatch(importingRoster());
    return uploadRoster(tourId, files)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        // TODO: handle import errors or warnings
        const payload = {};
        payload.tour = response.tour;
        const messages = [];
        messages.push({
          key: 'route-import-0',
          msg: `${response.users} users and ${response.groups} groups created.`,
        });
        response.warnings.forEach(warn => {
          messages.push({
            key: `route-import-${messages.length}`,
            msg: warn,
            style: 'warning',
          });
        });

        payload.messages = messages;
        return dispatch(receiveRosterImport(payload));
        // dispatch(requestTour(tourId));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/overview`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              return dispatch(
                importRosterFailure({
                  msg: detail.status,
                  key: 'roster-import',
                  style: 'danger',
                })
              );
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function requestProposals(tourId) {
  return dispatch => {
    dispatch(requestingProposals());
    return fetchProposal(tourId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveProposals(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/3`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!', error);
          // dispatch()
        }
      });
  };
}

export function requestBidsets(tourId) {
  return dispatch => {
    dispatch(requestingBidsets());
    return fetchBidsets(tourId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveBidsets(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/4`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function favoriteHotel(hotelId, favorite) {
  const payload = { favorite };
  return dispatch => {
    dispatch(requestingHotelFavorite());
    return setFavoriteHotel(hotelId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveHotelFavorite(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function selectHotel(eventId, payload) {
  return dispatch => {
    dispatch(requestingHotelSelect());
    return addHotel(eventId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        if (response.message) {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Hotel Select',
            message: response.message,
            autoDismiss: 20,
          };
          dispatch(Notifications.info(notificationOpts));
        }
        dispatch(receiveHotelSelect(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then(message => {
              const notificationOpts = {
                // uid: 'once-please', // you can specify your own uid if required
                title: 'Hotel Select',
                message: message.message,
                autoDismiss: 20,
              };
              return dispatch(Notifications.error(notificationOpts));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function searchHotels(eventId) {
  return dispatch => {
    dispatch(requestingHotels(eventId));
    return fetchSearchHotels(eventId)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveHotels(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function findHotels(eventId, name) {
  return dispatch => {
    dispatch(requestingHotelFind(name));
    return fetchFindHotels(eventId, name)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveFindHotel(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=/tours/${tourId}/hotels/2`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

function formatBrandData(jsonObject) {
  return jsonObject.map(item => ({
    label: item.name,
    value: item.id,
  }));
}
function formatPlaceData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.name} (${item.city}, ${item.state})`,
    value: item.id,
  }));
}
export function requestBrandOptions() {
  return dispatch => {
    dispatch(requestingBrands());
    return fetchBrands()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveBrands(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function requestPlaceOptions() {
  return dispatch => {
    dispatch(requestingPlaces());
    return fetchPlaces()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receivePlaces(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function saveBidset(id, payload) {
  return dispatch => {
    patchBidset(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveBidset(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push(`/login?next=${this.props.location.pathname}`));
            });
          }
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}


export function duplicateMemberError() {

  return dispatch => {
    const notificationOpts = {
      title: 'Yikes!',
      message: `Email address already in use`,
      autoDismiss: 15,
    };
    dispatch(Notifications.error(notificationOpts));
  }
}
export function dispatchRemoveMemberFromGroup(groupId, memberId) {
  return dispatch => {
    dispatch(removeMemberFromGroupRequest());
    return removeMemberFromGroup(groupId, { member: memberId })
      .then(checkHttpStatus)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Member Removed',
          message: 'Tour Member Removed.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(removeMemberFromGroupSuccess(memberId));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(removeMemberFromGroupFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(dispatchRemoveMemberFromGroup(memberId, groupId)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(dispatchRemoveMemberFromGroup(memberId, groupId)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(removeMemberFromGroupFailure(memberId));
      });
  };
}

export function removeGroup(group) {
  return dispatch => {
    dispatch(requestingGroupDelete(group.id));
    return deleteGroup(group.id)
      .then(checkHttpStatus)
      .then(response => {
        dispatch(requestGroupDeleteSuccess(group.id, response));
        dispatch(refreshTour(group.tour));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              dispatch(requestGroupDeleteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(removeGroup(group)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(removeGroup(id)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestGroupDeleteFailure(id));
      });
  };
}

export function newGroup(payload) {
  return dispatch => {
    dispatch(requestingAddGroup());
    addGroup(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveGroup(response));
        dispatch(refreshTour(response.tour));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function editGroup(id, payload) {
  return dispatch => {
    patchGroup(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveGroup(response));
        if (payload.name) {
          // refresh tour in group name changes
          dispatch(refreshTour(response.tour));
        }
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function saveRoomPreferences(prefId, payload) {
  return dispatch => {
    patchPreferences(prefId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          title: 'Room Preferences',
          message: 'Hotel room preferences are updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(clearBids());
        dispatch(receivePreferences(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function saveSearchPreferences(prefId, payload) {
  return dispatch => {
    patchPreferences(prefId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          title: 'Search Preferences',
          message: 'Hotel search preferences are updated.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(clearHotels());
        dispatch(receivePreferences(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}

export function sendProposal(proposalId, payload) {
  return dispatch => {
    updateProposal(proposalId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(receiveProposalSend(response));
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Requesting Bids',
          message: 'Catch is working to get your hotel pricing.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function sendBid(bidId, payload) {
  return dispatch => {
    fetchSendBid(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Bid Request Sent',
          message: 'Your bid request is on its way.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(receiveBidSend(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
        }
      });
  };
}
export function removeTourManager(id, payload) {
  return dispatch => {
    dispatch(removeTourManagerRequest());
    fetchRemoveTourManager(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Tour Manager Removed',
          message: 'Removed tour manager access.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(removeTourManagerSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Removing Tour Manager',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(removeTourManagerFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Removing Tour Manager',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(removeTourManagerFailure());
        }
      });
  };
}

export function sendToTourManager(id, payload) {
  return dispatch => {
    dispatch(sendToTourManagerRequest());
    fetchSendToTour(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Getting ready to collaborate',
          message: 'An invite is on the way.',
          autoDismiss: 20,
        };
        dispatch(Notifications.success(notificationOpts));
        return dispatch(sendToTourManagerSuccess(response));
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Sending to Tour Manager',
              message: 'Error sending the message. Please try again.',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
            return dispatch(sendToTourManagerFailure());
          }
        } else {
          // Most likely connection issues
          console.log('An error occurred while sending your data!');
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Sending to Tour Manager',
            message: 'Error sending the message. Please try again.',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
          return dispatch(sendToTourManagerFailure());
        }
      });
  };
}

const EXTENSIONS = { 'application/pdf': 'pdf', 'application/vnd.ms-excel': 'xlsx' };

function handleTourBlobDownload(blob) {
  const filename = `tour.${EXTENSIONS[blob.type.split(';')[0]]}`;
  if (navigator.appVersion.toString().indexOf('.NET') > 0) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    const a = document.querySelector('#pdf-link');
    a.href = url;
    a.download = filename;
    a.click();
  }
}
// application/vnd.ms-excel
// application/pdf
export function downloadTourPdf(id, payload) {
  return dispatch => {
    dispatch(tourDownloadRequest());
    const notificationOpts = {
      // uid: 'once-please', // you can specify your own uid if required
      title: 'Generating Doc',
      message: 'Exporting travel data.',
      autoDismiss: 20,
    };
    dispatch(Notifications.success(notificationOpts));
    fetchTourDownload(id, payload)
      .then(checkHttpStatus)
      // .then(parseJSON
      .then(response => response.blob())
      .then(blob => {
        handleTourBlobDownload(blob);
      })
      .catch(error => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then(detail => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then(detail => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Error in building document',
              message: 'Unable to generate document',
              autoDismiss: 20,
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Travel Doc Generation',
            message: 'Error downloading the file',
            autoDismiss: 20,
          };
          dispatch(Notifications.error(notificationOpts));
        }
      });
  };
}

function findById(value) {
  return value.id === Number(this);
}
function findByKey(value) {
  return value.key === this;
}
function findByGUID(value) {
  return value.id === this;
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BID_CLEAR]: (state, action) => {
    return update(state, {
      selectedTour: {
        bids: { $set: [] },
        proposals: { $set: [] },
        fetches: {
          proposals: { $set: { isFetching: false, needFetch: true } },
          bids: { $set: { isFetching: false, needFetch: true } },
        },
      },
    });
  },
  [BID_EDIT_REQUEST]: state =>
    update(state, {
      selectedTour: {
        isEditing: {
          $set: true,
        },
      },
    }),
  [BID_DELETE_SUCCESS]: (state, action) => {
    const id = action.payload;
    let proposalId = action.payload.proposal;

    const bidList = state.selectedTour.bids;
    const idx = bidList.findIndex(findById, id);
    let newState = state;
    // Update bids
    if (idx !== -1) {
      proposalId = state.selectedTour.bids[idx].proposal;

      newState = update(state, {
        selectedTour: {
          bids: { $set: [...bidList.slice(0, idx), ...bidList.slice(idx + 1)] },
        },
      });
    }
    const proposalIdx = state.selectedTour.proposals.findIndex(findById, proposalId);
    const bidIdx = state.selectedTour.proposals[proposalIdx].bids.findIndex(findById, id);
    const bids = state.selectedTour.proposals[proposalIdx].bids;
    if (bidIdx !== -1) {
      return update(newState, {
        selectedTour: {
          proposals: {
            [proposalIdx]: {
              bids: {
                $set: [...bids.slice(0, bidIdx), ...bids.slice(bidIdx + 1)],
              },
            },
          },
        },
      });
    }
    return newState;
  },
  [BID_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const proposalId = action.payload.proposal;

    const bidList = state.selectedTour.bids;
    const idx = bidList.findIndex(findById, id);
    let newState;
    // Update bids
    if (idx === -1) {
      newState = update(state, {
        selectedTour: {
          bids: { $push: [action.payload] },
        },
      });
    } else {
      newState = update(state, {
        selectedTour: {
          bids: {
            [idx]: { $set: action.payload },
          },
        },
      });
    }
    const proposalIdx = state.selectedTour.proposals.findIndex(findById, proposalId);
    if (proposalIdx === -1) {
      // Handle when proposals are not loaded
      return newState;
    }
    const bidIdx = state.selectedTour.proposals[proposalIdx].bids.findIndex(findById, id);
    if (bidIdx !== -1) {
      return update(newState, {
        selectedTour: {
          proposals: {
            [proposalIdx]: {
              bids: {
                [bidIdx]: { $set: action.payload },
              },
            },
          },
        },
      });
    }
    return newState;
    // TODO: save and update propsal as well
  },
  [BID_FILTER_SET]: (state, action) => {
    return update(state, {
      selectedTour: { bidFilter: { $merge: action.payload } },
    });
  },
  [BRAND_FETCH_SUCCESS]: (state, action) =>
    update(state, { brands: { $set: formatBrandData(action.payload) } }),
  [PLACE_FETCH_SUCCESS]: (state, action) => {
    const places = formatPlaceData(action.payload);
    sessionStorage.setItem('places', JSON.stringify(places));
    return update(state, { places: { $set: places } });
  },
  [EVENT_EDIT_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const event = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      if (stops[i].id === Number(action.payload.id)) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: { $set: event },
              },
            },
          },
        });
      }
      const idx = stops[i].events.findIndex(findById, action.payload.id);
      if (idx !== -1) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: {
                  events: { [idx]: { $set: event } },
                },
              },
            },
          },
        });
      }
    }
    return state;
  },
  [EVENT_DELETE_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const event = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      if (stops[i].id === Number(event)) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: { $set: [...stops.slice(0, i), ...stops.slice(i + 1)] },
            },
          },
        });
      }
      const idx = stops[i].events.findIndex(findById, event);
      if (idx !== -1) {
        const events = stops[i].events;
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                events: { $set: [...events.slice(0, idx), ...events.slice(idx + 1)] },
              },
            },
          },
        });
      }
    }
    return state;
  },
  [EVENT_FILTER_SET]: (state, action) => {
    return update(state, {
      selectedTour: { eventFilter: { $merge: action.payload } },
    });
  },
  [GROUP_EDIT_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload.id);
    const group = action.payload;
    if (idx !== -1) {
      return update(state, {
        selectedTour: { tour: { groups: { [idx]: { $set: group } } } },
      });
    }
    return update(state, {
      selectedTour: { tour: { groups: { $push: [group] } } },
    });
  },
  [GROUP_DELETE_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload);
    const newGroups = state.selectedTour.tour.groups;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            groups: { $set: [...newGroups.slice(0, idx), ...newGroups.slice(idx + 1)] },
          },
        },
      });
    }
    return state;
  },
  [GROUPMEMBER_REMOVE_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload);
    console.log('members = ', state.selectedTour.tour.members);
    const newMembers = state.selectedTour.tour.members;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: { $set: [...newMembers.slice(0, idx), ...newMembers.slice(idx + 1)] },
          },
        },
      });
    }
    return state;
  },
  [GROUPEVENT_EDIT_SUCCESS]: (state, action) => {
    const stops = state.selectedTour.tour.tour_stops;
    const groupEvent = action.payload;
    for (let i = 0, len = stops.length; i < len; i++) {
      const idx = stops[i].related_group_events.findIndex(findById, action.payload.id);
      if (idx !== -1) {
        return update(state, {
          selectedTour: {
            tour: {
              tour_stops: {
                [i]: {
                  related_group_events: { [idx]: { $set: groupEvent } },
                },
              },
            },
          },
        });
      }
    }
    return state;
  },
  [MEMBER_ADD_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
      });
    }
    return update(state, {
      selectedTour: {
        tour: {
          members: { $push: [action.payload] },
        },
      },
    });
  },
  [MEMBER_EDIT_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.members.findIndex(findById, action.payload.id);
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          tour: {
            members: {
              [idx]: { $set: action.payload },
            },
          },
        },
      });
    }
    return update(state, {
      selectedTour: {
        tour: {
          members: { $push: [action.payload] },
        },
      },
    });
  },
  [SEARCH_PREFS_FETCH_SUCCESS]: (state, action) => {
    const idx = state.selectedTour.tour.groups.findIndex(findById, action.payload.group);
    if (idx !== -1) {
      const prefs = action.payload;
      return update(state, {
        selectedTour: {
          tour: {
            groups: {
              [idx]: { hotel_prefs: { $set: prefs } },
            },
          },
        },
      });
    }
    return state;
  },
  [SEARCH_HOTEL_CLEAR]: (state, action) => {
    return update(state, {
      hotels: { $set: {} },
      fetchingHotels: { $set: {} },
    });
  },
  [SEARCH_HOTEL_FETCH_REQUEST]: (state, action) => {
    const eventId = action.payload;
    return update(state, {
      fetchingHotels: {
        [eventId]: { $set: true },
      },
    });
  },
  [SEARCH_HOTEL_FETCH_SUCCESS]: (state, action) => {
    const eventId = action.payload.event;
    const newState = update(state, {
      fetchingHotels: {
        [eventId]: { $set: false },
      },
    });
    return update(newState, {
      hotels: {
        [eventId]: { $set: action.payload.hotels },
      },
    });
  },
  [EVENT_SELECT]: (state, action) => {
    return update(state, {
      selectedTour: {
        selectedEvent: { $set: action.payload },
      },
      findHotels: { $set: { hotels: [], fetching: false, search: '' } },
    });
  },
  [HOTEL_FAVORITE_FETCH_SUCCESS]: (state, action) => {
    const hotelId = action.payload.hotel;
    let newState = state;
    let changed = false;
    for (const eventId in state.hotels) {
      const hotelList = { [eventId]: state.hotels[eventId] };
      const idx = hotelList[eventId].findIndex(findByGUID, hotelId);
      if (idx !== -1) {
        const hotel = { favorite: action.payload.favorite };
        if (changed) {
          newState = update(newState, {
            hotels: {
              [eventId]: { [idx]: { $merge: hotel } },
            },
          });
        } else {
          newState = update(state, {
            hotels: {
              [eventId]: { [idx]: { $merge: hotel } },
            },
          });
        }
        changed = true;
      }
    }
    if (changed) {
      return newState;
    }
    return state;
  },
  [HOTEL_FIND_FETCH_REQUEST]: (state, action) =>
    update(state, {
      findHotels: { $merge: { fetching: true, search: action.payload, hotels: [] } },
    }),
  [HOTEL_FIND_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      findHotels: { $set: { hotels: action.payload, fetching: false } },
    }),
  [HOTEL_SELECT_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: {
        fetches: {
          proposals: { $set: { isFetching: false, needFetch: true } },
          bids: { $set: { isFetching: false, needFetch: true } },
        },
      },
    });
  },
  [HOTEL_SELECT_FETCH_SUCCESS]: (state, action) => {
    const eventId = action.payload.event;
    const hotelList = state.hotels[eventId];
    const hotelId = action.payload.hotels[0].id;
    const findList = state.findHotels.hotels;
    const idx = hotelList.findIndex(findByGUID, hotelId);
    if (idx === -1) {
      const newstate = update(state, {
        hotels: {
          [eventId]: { $push: action.payload.hotels },
        },
      });
      // Check if hotel is find window
      const fidx = findList.findIndex(findByGUID, hotelId);
      if (fidx !== -1) {
        return update(newstate, {
          findHotels: {
            hotels: {
              [fidx]: { $set: action.payload.hotels[0] },
            },
          },
        });
      }
      return newstate;
    }
    return update(state, {
      hotels: {
        [eventId]: {
          [idx]: { $set: action.payload.hotels[0] },
        },
      },
    });
  },
  [BIDSET_LIST_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { fetches: { bids: { $set: { isFetching: true, needFetch: false } } } },
    }),
  [BIDSET_LIST_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      selectedTour: {
        bids: { $set: action.payload },
        fetches: { bids: { $set: { isFetching: false, needFetch: false } } },
      },
    }),
  [PROPOSAL_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { fetches: { proposals: { $set: { isFetching: true, needFetch: false } } } },
    }),
  [PROPOSAL_FETCH_SUCCESS]: (state, action) =>
    update(state, {
      selectedTour: {
        proposals: { $set: action.payload },
        fetches: { proposals: { $set: { isFetching: false, needFetch: false } } },
      },
    }),
  [PROPOSAL_SEND_SUCCESS]: (state, action) => {
    const proposalId = action.payload.id;
    const proposalList = state.selectedTour.proposals;
    const idx = proposalList.findIndex(findById, proposalId);
    if (idx === -1) {
      return update(state, {
        selectedTour: {
          proposals: { $push: action.payload },
        },
      });
    }
    return update(state, {
      selectedTour: {
        proposals: {
          [idx]: { $set: action.payload },
        },
      },
    });
  },
  [CLEAR_ROUTE_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { routeIsProcessing: { $set: true } },
    }),
  [CLEAR_ROUTE_FETCH_SUCCESS]: (state, action) => {
    return update(state, {
      selectedTour: {
        messages: { $set: action.payload.messages },
        routeIsProcessing: { $set: false },
        tour: { $set: action.payload.tour },
        proposals: { $set: [] },
        bids: { $set: [] },
        fetches: {
          bids: { $set: { isFetching: false, needFetch: true } },
          proposals: { $set: { isFetching: false, needFetch: true } },
        },
      },
    });
  },
  [CLEAR_ROUTE_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
    return update(newState, {
      selectedTour: { messages: { $merge: [action.payload] } },
    });
  },
  [IMPORT_ROUTE_FETCH_REQUEST]: (state, action) =>
    update(state, {
      selectedTour: { routeIsProcessing: { $set: true } },
    }),
  [IMPORT_ROUTE_FETCH_PENDING]: (state, action) => {
    if (action.payload) {
      return update(state, {
        selectedTour: { messages: { $merge: [action.payload] } },
      });
    }
    return state;
  },
  [IMPORT_ROUTE_FETCH_SUCCESS]: (state, action) => {
    const newState = update(state, {
      selectedTour: { tour: { $set: action.payload.tour } },
    });
    const newState2 = update(newState, {
      selectedTour: { messages: { $set: action.payload.messages } },
    });
    return update(newState2, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
  },
  [IMPORT_ROUTE_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
    return update(newState, {
      selectedTour: { messages: { $merge: [action.payload] } },
    });
  },
  [IMPORT_ROSTER_FETCH_REQUEST]: (state, action) => {
    return update(state, {
      selectedTour: { rosterIsProcessing: { $set: true } },
    });
  },
  [IMPORT_ROSTER_FETCH_SUCCESS]: (state, action) => {
    const newState = update(state, {
      selectedTour: { tour: { $set: action.payload.tour } },
    });
    const newState2 = update(newState, {
      selectedTour: { messages: { $set: action.payload.messages } },
    });
    return update(newState2, {
      selectedTour: { routeIsProcessing: { $set: false } },
    });
  },
  [IMPORT_ROSTER_FETCH_FAILURE]: (state, action) => {
    const newState = update(state, {
      selectedTour: { rosterIsProcessing: { $set: false } },
    });
    return update(newState, {
      selectedTour: { messages: { $merge: [action.payload] } },
    });
  },
  [TOUR_FILTER_SET]: (state, action) => {
    return update(state, {
      tourStateFilter: { $merge: action.payload },
    });
  },
  [TOUR_SELECT]: (state, action) => {
    const selectedTour = initialSelectedTour;
    selectedTour.id = action.payload;
    selectedTour.isFetching = false;
    selectedTour.needFetch = true;
    return update(state, {
      selectedTour: { $set: selectedTour },
    });
  },
  // eslint-disable-next-line no-unused-vars
  [TOUR_LIST_FETCH_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      isFetching: true,
      hasError: false,
    }),
  [TOUR_LIST_FETCH_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      isFetching: false,
      needFetch: false,
      hasError: false,
      selectedEvent: null,
      tours: action.payload,
    }),
  // eslint-disable-next-line no-unused-vars
  [TOUR_FETCH_REQUEST]: (state, action) => {
    const selectedTour = Object.assign({}, initialSelectedTour);
    selectedTour.id = action.payload;
    selectedTour.isFetching = true;
    selectedTour.needFetch = false;
    return update(state, {
      selectedTour: { $set: selectedTour },
    });
  },
  [TOUR_FETCH_SUCCESS]: (state, action) => {
    const selectedTour = Object.assign({}, initialSelectedTour);
    action.payload.manager = action.payload.managers[0].id.toString();
    selectedTour.id = action.payload.id;
    selectedTour.isFetching = false;
    selectedTour.needFetch = false;
    selectedTour.tour = action.payload;
    const idx = state.tours.findIndex(findById, action.payload.id);
    if (idx === -1) {
      return update(state, {
        selectedTour: { $set: selectedTour },
        tours: { $push: [action.payload] },
      });
    }
    return update(state, {
      selectedTour: { $set: selectedTour },
      tours: { [idx]: { $set: action.payload } },
    });
  },
  [TOUR_FETCH_FAILURE]: (state, action) => {
    return update(state, {
      selectedTour: {
        $set: {
          id: action.payload,
          isFetching: false,
          needFetch: false,
          hasError: true,
          tour: {},
        },
      },
    });
  },
  [TOUR_EDIT_SUCCESS]: (state, action) => {
    const idx = state.tours.findIndex(findById, action.payload.id);
    action.payload.manager = action.payload.managers[0].id.toString();
    if (idx === -1) {
      return update(state, {
        tours: { $push: [action.payload] },
        selectedTour: { tour: { $set: action.payload } },
      });
    }
    return update(state, {
      tours: { [idx]: { $set: action.payload } },
      selectedTour: { tour: { $set: action.payload } },
    });
  },
  [TOURMGR_REMOVE_SUCCESS]: (state, action) => {
    const tour = action.payload.tour;
    if (tour) {
      return update(state, {
        selectedTour: {
          tour: { $set: tour },
        },
      });
    }
    return state;
  },
  [TOURMGR_SEND_TOUR_SUCCESS]: (state, action) => {
    const tour = action.payload.tour;
    if (tour) {
      return update(state, {
        selectedTour: {
          tour: { $set: tour },
        },
      });
    }
    return state;
  },
  [TOURMGR_SIM_MODE]: (state, action) => {
    return update(state, {
      tourManagerSim: { $set: action.payload },
    });
  },
  [TOUR_MESSAGE_SET]: (state, action) => {
    const idx = state.selectedTour.messages.findIndex(findByKey, action.payload.key);
    const messages = state.selectedTour.messages;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          messages: { $set: [action.payload] },
        },
      });
    }
    return update(state, {
      selectedTour: {
        messages: { $set: [action.payload] },
      },
    });
  },
  [TOUR_MESSAGE_DISMISS]: (state, action) => {
    const idx = state.selectedTour.messages.findIndex(findByKey, action.payload.key);
    const messages = state.selectedTour.messages;
    // Update bids
    if (idx !== -1) {
      return update(state, {
        selectedTour: {
          messages: { $set: [...messages.slice(0, idx), ...messages.slice(idx + 1)] },
        },
      });
    }
    return state;
  },

  [TOUR_MANAGER_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      tourManagers: []
    }),
  [TOUR_MANAGER_SUCCESS]: (state, action) => {

    // const data = [];
    // for (let index = 0; index < action.payload.agents.length; index++) {
    //   const element = action.payload.agents[index];
    //   data.push({
    //     value :element.element,
    //     label : element.username
    //   })
    // }

    return Object.assign({}, state, {
      tourManagers: action.payload.agents
    })
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function toursReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}




// WEBPACK FOOTER //
// src/routes/tours/modules/tour.js